import { IconButton, Tooltip } from '@mui/material';
import { Delete } from 'mdi-material-ui';
import React from 'react';
import { useIntl } from 'react-intl';

interface DeleteCommentButtonProps {
    commentId: number;
    deleteComment: (data: { commentId: number }) => void;
    disabled: boolean;
}

export const DeleteCommentButton: React.FC<DeleteCommentButtonProps> = ({ commentId, deleteComment, disabled }) => {
    const intl = useIntl();
    return (
        <>
            <Tooltip title={intl.formatMessage({ id: 'document.comment.delete' })} placement="top">
                <IconButton
                    color="error"
                    size="small"
                    edge="end"
                    disabled={disabled}
                    onClick={() => deleteComment({ commentId })}
                    sx={{ padding: 0 }}
                >
                    <Delete fontSize="small" />
                </IconButton>
            </Tooltip>
        </>
    );
};
